// JIRA LPPLWEBMOB-563
import * as yup from "yup";

import { summaryConsentValidatorRequired } from "../../../utilities/validators/summaryConsent";

import { ComponentId } from "./enums";

export const validator = yup.object().shape({
  [ComponentId.CORRECTNESS_AGREEMENT]: summaryConsentValidatorRequired,
  /* Zgody dobrowolne */
  /*  
  [ComponentId.AGREE_DECISION_EMAIL]: summaryConsentValidatorRequired,
  [ComponentId.AGREE_RENTIN_VEHICLE_EMAIL]: summaryConsentValidatorRequired,
  [ComponentId.AGREE_CONTACT_EMAIL]: summaryConsentValidatorRequired,
  */
});
